export default __webpack_public_path__ + "static/media/Lip_1_M.f9f548fa.svg";